import React, { Component } from 'react';
import PropTypes from 'prop-types';
// common components
import CustomButton from './../../common/Forms/CustomButton/CustomButton';
import Modal from './../../common/Modal/Modal';
import PageHeader from './../../common/PageHeader/PageHeader';
import Pagination from './../../common/Pagination/Pagination';
// components
import CourseDetails from './CourseDetails/CourseDetails';
import ManageModule from './ManageModule/ManageModule';
import ModuleList from './ModuleList/ModuleList';

class CourseModule extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalOpen: false,
			title: '',
			courseId: this.props.match.params.course_id,
			moduleId: '',
			moduleDetails: {
				name: '',
				description: ''
			},
			breadcrumb: [
				{
					name: 'Course',
					url: '/course',
					fn: () => this.props.history.go(-1)
				}
			]
		}
		this.manageModules = this.manageModules.bind(this);
		this.moduleQuestion = this.moduleQuestion.bind(this);
		this.onChange = this.onChange.bind(this);
		this.moduleUpdate = this.moduleUpdate.bind(this);
	}

	componentDidMount() {
		const { courseId } = this.state;
		const { moduleContext, courseContext } = this.props;
		
		moduleContext.getModuleList(courseId, 1, 25);
		courseContext.getCourseDetails(courseId);
	}

	componentWillUnMount() {
		this.props.moduleContext.clearModuleList();
    	this.props.commonContext.updatePagination();
		this.props.commonContext.updateLoaderMsg();
	}

	componentWillReceiveProps(nextProps) {
		const { title } = this.state;
		const { moduleDetails: {name, description} } = nextProps.moduleContext;
		const { moduleDetails } = this.props.moduleContext;

		if ( title === 'edit' ) {
			this.setState({ moduleDetails: { name, description } });
		}
	}

	// pagination
	onChangePage = (curr_page, size) => {
		this.props.moduleContext.getModuleList(this.state.courseId, curr_page, size);
	}

	// Modal (course_module)

		// open Modal (course_module)
		manageModules(value, title = null, id = null) {
			const { getModuleDetails, clearModuleDetails} = this.props.moduleContext;
			
			if (value) {
				if (title !== 'add') {
					this.setState({ moduleId: id });
					if (title === 'edit') {
						getModuleDetails(id);
					}
				}
			} else {
				this.setState({
					moduleId: '',
					moduleDetails: {
						name: '',
						description: ''
					}
				});
				clearModuleDetails();
			}
			this.setState({
				modalOpen: value,
				title
			});
		};

		// modal onchange fields (course_module)
		onChange = (e) => {
			this.setState({
				moduleDetails: {
					...this.state.moduleDetails,
					[e.target.name]: e.target.value
				}
			});
		}

		// confirm button
		moduleUpdate = () => {
			const { title, moduleId, moduleDetails: {name, description}, courseId } = this.state;
			const { updateModuleDetails, addModule, deleteModule } = this.props.moduleContext;

			if (title === 'edit') {
				let data = {
					id: moduleId,
					name,
					description
				}
				updateModuleDetails(data, courseId);
			} else if (title === 'add') {
				let data = {
					name,
					description
				}
				addModule(data, courseId);
			} else if (title === 'delete') {
				deleteModule(moduleId, courseId);
			}
		}

	// route to question_page
	moduleQuestion(module_id) {
		const { history } = this.props;
		history.push(`${this.props.match.url}/mq/${module_id}`);
	}

	render() {
		const { moduleList, moduleDetails } = this.props.moduleContext;
		const { pagination } = this.props.commonContext;
		const { courseDetails } = this.props.courseContext;
		const { breadcrumb, modalOpen, title, moduleDetails: {name, description} } = this.state;
		const disabled = name === '' ||
							(name === moduleDetails.name && description === moduleDetails.description);
		return (
			<div className='CourseModule'>
				<CourseDetails
					courseDetails={courseDetails}
					links={breadcrumb}
					moduleLength={pagination && pagination.numberOfElements ? pagination.numberOfElements : moduleList.length}
				/>

				<PageHeader
					title='Modules'
					btnText='Module'                    					
					onAdd={() => this.manageModules(true, 'add')}
				/>

				<ModuleList
					moduleQuestion={this.moduleQuestion}
					manageModules={this.manageModules}
					moduleList={moduleList}
				/>
				{pagination && pagination.totalElements > 0 &&
					<Pagination
						totalPage={pagination.totalPages}
						onChangePage={this.onChangePage}
						count={pagination.totalElements}
						first={pagination.first}
						last={pagination.last}
					/>
				}

				{/* Add, Edit, and delete Course Modal */}
					{modalOpen &&
						<Modal
							modalOpen={modalOpen}
							toggleModal={this.manageModules}
							title={title}
							confirm={this.moduleUpdate}
							disabled={title !== 'delete' && disabled}
						>
							<ManageModule
								value={this.state.moduleDetails}
								onDelete={title === 'delete'}
								onChange={(e) => this.onChange(e)}
							/>
						</Modal>
					}
				{/* Add, Edit, and delete Course Modal */}
			</div>
		);
	}
}


CourseModule.propTypes = {
	history: PropTypes.instanceOf(Object),
	match: PropTypes.instanceOf(Object),
	moduleContext: PropTypes.instanceOf(Object),
	courseContext: PropTypes.instanceOf(Object)
};

CourseModule.defaultProps = {
	history: {},
	match: {},
	moduleContext: {},
	courseContext: {}
};

export default CourseModule;



// WEBPACK FOOTER //
// ./components/CourseModule/CourseModule.js